import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { AlertPopupPage } from './alert-popup.page';
import { DesktopComponentsModule } from '../../desktop/desktop-components.module';

@NgModule({
  declarations: [AlertPopupPage],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    DesktopComponentsModule
  ]
})
export class AlertPopupModule { }
